/** Source of truth for /resume. Update here; JSON/Word/PDF exports use this file. */
export const RESUME = {
  meta: {
    updated: "2026-10-27",
    version: "1.2.0",
  },
  name: "Young He",
  pronouns: "she/her",
  headline: "Product Designer · B2B SaaS, marketplaces, design systems",
  tagline: "",
  contact: {
    email: "jiadiyounghe@gmail.com",
    website: "https://youngdesign.world",
    location: "Vancouver, BC",
    openTo: "",
    status: "Canadian PR",
    agentLabel: "",
    agentPath: "",
    address: "",
    languages: "",
  },
  summary: "",
  experience: [
    {
      company: "Collabstr",
      title: "Founding Product Designer",
      dates: "Dec 2025 – Present",
      location: "Vancouver, BC",
      bullets: [
        "Shipped a live design system. Delivery ~25% faster.",
        "AI campaign flow. Conversion 1.2% → 4%.",
        "Task completion 14.9% → 52%. Revenue +103% YoY in Q1.",
      ],
    },
    {
      company: "Intranet Connections",
      title: "Product Designer",
      dates: "Jul 2023 – Nov 2025",
      location: "Vancouver, BC",
      bullets: [
        "Redesigned an intranet used by 500+ enterprises.",
        "Access control: 12 roles → 5, 20 pages → 2. Adoption +50%.",
        "Design system. UI defects down 70%.",
      ],
    },
    {
      company: "Safe Air Mobility",
      title: "UX/UI Designer",
      dates: "May 2023 – Jul 2023",
      location: "Remote",
      bullets: ["Designed a drone insurance platform from 0 to 1."],
    },
    {
      company: "Freelance",
      title: "UI/UX Designer",
      dates: "Jan 2022 – Jul 2023",
      location: "Vancouver, BC",
      bullets: ["UX for websites and community platforms."],
    },
    {
      company: "Hailiang Education Group",
      title: "Admission & marketing coordinator",
      dates: "Jan 2019 – Dec 2019",
      location: "China",
      bullets: ["Admissions and marketing: events, materials, family communication."],
    },
    {
      company: "Hailiang Art School",
      title: "ESL Teacher",
      dates: "2017 – 2020",
      location: "China",
      bullets: ["Taught English. Lessons and materials for mixed-level classrooms."],
    },
  ],
  education: [
    {
      school: "University of British Columbia",
      degree: "MEd, Human Development Psychology",
      dates: "2020 – 2022",
    },
    {
      school: "Wenzhou University",
      degree: "B.A., English Literature",
      dates: "2013 – 2017",
    },
  ],
  credentials: [],
  skills: ["Figma", "Design systems", "React", "React Native", "Prototyping", "User research", "HTML/CSS"],
  selectedWork: [],
};

export function resumeAsJson() {
  return JSON.stringify(RESUME, null, 2);
}

export function skillsList(skills = RESUME.skills) {
  if (Array.isArray(skills)) return skills;
  return Object.values(skills).flat();
}
